import { useMemo } from "react";
import { useEffect, useState } from "react";
import { useAppSelector } from "../../../store";
import { storedLocale } from "../../Authentication/util";
import { useGetWhosCloseQuery } from "../../../services/ActionReports/ActionReportAPI";
import type { WhosCloseResponse } from "../../../services/ActionReports/ActionReportAPI.types";
import { useWatchlistFetch } from "../hooks/useWatchlistFetch";
import { getBusinessNatures } from "../utils/businessNature";

export const defaultWhosCloseActionReportData = (): WhosCloseResponse => {
  return {
    whosClose: [],
    errors: [],
    callResults: [],
  };
};

export const FetchWhosCloseActionReportData = (period: string, skipRequest = false) => {
  const { user, configuration } = useAppSelector((state) => state.boot);
  const { actionReports } = configuration;

  const businessNature = useMemo(
    () => getBusinessNatures(user.aff, actionReports?.disableCustomerMembers ?? false),
    [user.aff, actionReports?.disableCustomerMembers],
  );

  const {
    data: payloadData,
    isFetching,
    isError,
    refetch,
  } = useGetWhosCloseQuery(
    {
      Aff: user.aff,
      Abo: user.abo,
      Period: period,
      Locale: storedLocale(),
      StartRange: "0",
      EndRange: "10",
      BusinessNature: businessNature,
    },
    {
      skip: skipRequest,
    },
  );

  const { isLoading: isLoadingWatchlist } = useWatchlistFetch();

  const [isLoading, setIsLoading] = useState(true);
  const [errorStatus, setErrorStatus] = useState(false);
  const [whosCloseActionReportData, setWhosCloseActionReportData] = useState<WhosCloseResponse>(
    defaultWhosCloseActionReportData(),
  );

  useEffect(() => {
    // Only stop loading when both report data AND watchlist are ready
    setIsLoading(isFetching || isLoadingWatchlist);
    setErrorStatus(isError);

    if (!isFetching && !isError && payloadData) {
      setWhosCloseActionReportData(payloadData);
    }
  }, [isFetching, period, isError, payloadData, isLoadingWatchlist]);

  return { isLoading, whosCloseActionReportData, errorStatus, refetch };
};
